import { Dispatch, CSSProperties, SetStateAction } from "react";
import { useAtomValue } from "jotai";
import { Icon } from "@zapier/zinnia-icons";
import { isBlockedUrl, isZapierUrl } from "@zapier/rich-text-editor";
import { isPublicAtom, togglesAtomResettable } from "@zapier/canvas-state";

import styles from "./ExternalLink.module.css";

type Props = {
  href: string;
  style: CSSProperties;
  setShowLinkConfirmation: Dispatch<SetStateAction<boolean>>;
  setShowLinkBlocked: Dispatch<SetStateAction<boolean>>;
};

export function ExternalLink({
  href,
  style,
  setShowLinkConfirmation,
  setShowLinkBlocked,
}: Props) {
  const isPublic = useAtomValue(isPublicAtom);
  const { blocked_domains } = useAtomValue(togglesAtomResettable);
  const blockedDomains = blocked_domains.config.domains;

  const handleLinkClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();

    // Only show warning for public canvases with external (non-Zapier) URLs
    if (isPublic && href && !isZapierUrl(href)) {
      if (isBlockedUrl(href, blockedDomains)) {
        setShowLinkBlocked(true);
        return;
      }

      setShowLinkConfirmation(true);
    } else {
      // For non-public canvases or Zapier URLs, open link directly
      window.open(href, "_blank");
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      className={styles.offsiteLink}
      style={style}
      onClick={handleLinkClick}
    >
      <Icon name="arrowOffsite" size={15} />
    </a>
  );
}
